var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSkipForward = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29242 27.7076C5.90253 27.3177 5.90253 26.6856 6.29242 26.2957L16.1645 16.4236C16.3984 16.1896 16.3984 15.8104 16.1645 15.5764L6.29242 5.70434C5.90253 5.31444 5.90253 4.68231 6.29242 4.29242C6.68231 3.90253 7.31445 3.90253 7.70434 4.29242L17.5764 14.1645C18.5901 15.1782 18.5901 16.8218 17.5764 17.8355L7.70434 27.7076C7.31445 28.0975 6.68231 28.0975 6.29242 27.7076Z",
    fill: "#0D0F13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 4C25.5523 4 26 4.44772 26 5V27C26 27.5523 25.5523 28 25 28C24.4477 28 24 27.5523 24 27V5C24 4.44772 24.4477 4 25 4Z",
    fill: "#0D0F13"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSkipForward);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/skip_forward.7be2f1b9c9d13cd8d690c4dd627b8ffa.svg";